import {ChangeDetectorRef, EventEmitter, Input, Output} from "@angular/core";
import {isArray} from "../ccl-util";
import {ListService} from "../list.service";
import {CclControlValueAccessor} from "./ccl-control-value-accessor";

export class ListControlValueAccessor extends CclControlValueAccessor {
    constructor(protected listService: ListService, cdr: ChangeDetectorRef) {
        super(cdr);
    }

    // ç»ä»¶åå§æ°æ®
    @Input()
    set sourceList(sourceList: any[]) {
        this.buildSourceList(sourceList);
    };

    get sourceList() {
        return this._sourceList;
    }

    _sourceList = [];

    // ç»ä»¶æ ¼å¼ååçæ°æ®
    dataList = [];

    // å½è®¾ç½®è¯¥å¼æ¶ï¼å°è°ç¨ç¨æ·é¢è®¾æå¡ï¼è¿åç»ä»¶æ°æ®
    @Input()
    invokeService = '';

    // è¯¥å¼ç¨å¨è°ç¨ç¨æ·é¢è®¾æå¡æ¶ï¼ä¼ éåæ°ä½¿ç¨
    @Input()
    invokeServiceParam: any = {};

    // å¤çéæ åæ°æ®æ¶ï¼å¯ä»¥ä½¿ç¨èªå®ä¹value
    @Input()
    customValueKey = 'valueCode';

    // å¤çéæ åæ°æ®æ¶ï¼å¯ä»¥ä½¿ç¨èªå®ä¹label
    @Input()
    customLabelKey = 'valueName';

    // ç»ä»¶å¼(nameé¨å)
    @Input()
    valueName;
    @Output()
    valueNameChange = new EventEmitter();

    // ç»ä»¶å¼(åå§æ°æ®)
    @Input()
    sourceValue;
    @Output()
    sourceValueChange = new EventEmitter();

    loading = false; // å½åçå¼æ­¥æ°æ®è¯·æ±æ¶ï¼è¯¥å¼ä¸ºtrueï¼ä¸ææ¡å°ææ¶ä¸å¯ç¨

    initNgOnChanges = false;

    // ********************* invokeService *********************
    // å è½½ç¨æ·èªå®ä¹æå¡æ°æ®
    async loadInvokeServiceData() {
        this.loading = true;
        const res: any = await this.listService.invokeListProvider(this.invokeService, this.invokeServiceParam).toPromise();
        this.buildSourceListAsRes(res);
        this.loading = false;
    }

    // è§£ææ°æ®ï¼ä½¿å¾ç»ä»¶å¯ä»¥æ¾ç¤ºæ°æ®
    buildSourceList(sourceList: any[], append?: boolean) {
        if (isArray(sourceList)) {
            const dataList = [];
            sourceList.forEach((item) => {
                dataList.push({
                    value: String(item[this.customValueKey || 'valueCode']),
                    label: String(item[this.customLabelKey || 'valueName']),
                    _source: item
                });
            });

            if (append) {
                this.dataList.push(...dataList);
            } else {
                this.dataList = dataList;
            }
        }
        if (append) {
            this._sourceList.push(...sourceList);
        } else {
            this._sourceList = sourceList;
        }
    }

    // è§£æä½¿ç¨ Result åè£çæ°æ®
    buildSourceListAsRes(res: any) {
        if (isArray(res)) {
            this.buildSourceList(res);
        } else if (res.code === 0 && isArray(res.data)) {
            this.buildSourceList(res.data);
        }
    }
}
